<template>
	<div
		:class="[
			'btn-progress',
			...variantClassList,
			isLoading && 'is-loading',
			hasLoaded && 'has-loaded',
			isActionRibbon && 'is-action-ribbon',
			isOutline && 'is-outline'
		]"
		v-if="isLoading || hasLoaded || hasError"
	>
		<span class="btn-progress__loading" v-if="isLoading">
			<div class="btn-progress__spinner">
				<div class="spin"></div>
				<div class="spin"></div>
				<div class="spin"></div>
				<div class="spin"></div>
			</div>
		</span>
		<!-- For Dev, Once the action is finished, the button will be in a successful state for 1 second before returning to the active state. -->
		<span class="btn-progress__loaded" v-if="hasLoaded">
			<i class="icon icon-circle-check "></i>
		</span>

		<Tooltip
			class="btn-progress__error"
			:visible="hasError"
			state="negative"
			v-if="hasError"
		>
			{{ errorMessage }}
		</Tooltip>
	</div>
</template>

<script>
import variantClasses from './variant-classes/button-progress-variant-classes';
import componentVariantMixin from '@/mixins/component-variant-mixin';
import Tooltip from '@/components/shells/tooltip/tooltip.vue';

export default {
	components: { Tooltip },
	name: 'ButtonProgress',
	mixins: [componentVariantMixin],
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		hasLoaded: {
			type: Boolean,
			default: false
		},
		hasError: {
			type: Boolean,
			default: false
		},
		errorMessage: {
			type: String,
			default: ''
		},
		isActionRibbon: {
			type: Boolean,
			default: false
		},
		isOutline: {
			type: Boolean,
			default: false
		}
	},
	created() {
		this.variantClasses = variantClasses;
	}
};
</script>

<style lang="scss" scoped>
/* @include spin('.icon-loading'); */

.btn-progress {
	@include transform-full-center;
	width: calc(100% + 2px);
	height: calc(100% + 2px);
	color: var(--ui-positive);

	&.is-loading::before,
	&.has-loaded:before {
		content: '';
		width: 100%;
		height: 100%;
		@include transform-full-center;
		border-radius: $border-radius;
	}

	&.is-loading::before {
		background-color: rgba(var(--btn-progress-bg_rgb), 0.5);
	}

	&.has-loaded:before {
		background-color: var(--btn-progress-bg);
	}

	&__loading,
	&__loaded {
		@include transform-full-center;
		font-size: 18px;
	}

	&__spinner {
		display: inline-block;
		position: relative;
		width: 30px;
		height: 30px;

		& .spin {
			box-sizing: border-box;
			display: block;
			position: absolute;
			width: 16px;
			height: 16px;
			margin: 8px;
			border: 2px solid var(--neutral-5);
			border-radius: 50%;
			animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
			border-color: var(--neutral-5) transparent transparent transparent;
		}

		& .spin:nth-child(1) {
			animation-delay: -0.45s;
		}
		& .spin:nth-child(2) {
			animation-delay: -0.3s;
		}
		& .spin:nth-child(3) {
			animation-delay: -0.15s;
		}
	}

	@keyframes lds-ring {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
}

.btn-icon.btn-icon--outline .btn-progress {
	&.is-loading::before,
	&.has-loaded:before {
		border-radius: 50%;
	}
}

.btn-small.btn-small--text .btn-progress {
	width: 100%;
	height: 100%;
}
</style>
